import { render } from "./BoatShop.vue?vue&type=template&id=5cc49c5c"
import script from "./BoatShop.vue?vue&type=script&lang=js"
export * from "./BoatShop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__